import { render, staticRenderFns } from "./SettingsSubheader.vue?vue&type=template&id=683ead75&"
import script from "./SettingsSubheader.vue?vue&type=script&lang=js&"
export * from "./SettingsSubheader.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSubheader.vue?vue&type=style&index=0&id=683ead75&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports